import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { SORT_DIRECTION } from 'emma-common-ts';

import type { EMMATableSortChangeEvent } from './emma-table/emma-table.types';
export interface EMMAPagination {
  /* PAGINATION */
  curPage: number;
  maxPage: number;
  limit: number;
  sortProp: string | number | symbol;
  sortDirection: SORT_DIRECTION;
  inputFilter: string;
  inputFilterProps: string[];
  onFilterInputChange: (inputFilter: string) => void;
  onSortChange: (event: EMMATableSortChangeEvent) => void;
  onLimitChange: (limit: number) => void;
  onPageChange: (curPage: number) => void;
}

@Component({
    selector: 'emma-pagination',
    templateUrl: './emma-pagination.component.html',
    standalone: false
})
export class EMMAPaginationComponent implements OnInit, OnChanges {
  @Input() curPage = 0;
  @Output() curPageChange = new EventEmitter<number>();

  @Input() maxPage = 0;
  @Input() maxPageLinks = 10;
  @Input() hasMorePages = false;

  availablePages: number[] = [];
  pages: Array<number | null> = [];

  ngOnInit(): void {
    this.updatePages();
  }

  ngOnChanges(): void {
    this.updatePages();
  }

  onChangePage = (curPage: number): void => {
    this.curPage = curPage;
    this.curPageChange.emit(curPage);
  };

  updatePages = (): void => {
    this.availablePages = Array(this.maxPage + 1)
      .fill(0)
      .map((__, i) => i);
    const { length } = this.availablePages;
    if (length > this.maxPageLinks) {
      this.pages = [];

      // metemos las intermedias, calculamos el slice
      // mitad para cada lado
      const around = Math.max(this.maxPageLinks - 1, 0);
      const half = Math.round(around / 2);

      let begin = this.curPage - half;
      let end = this.curPage + half + 1;

      // sobran en el principio, se meten del final
      if (begin < 0) {
        end = end - begin;
        begin = 0;
      }
      // sobran en el final, se meten al principio
      if (end > length) {
        begin = begin + (end - length);
        end = length;
      }

      this.pages.push(...this.availablePages.slice(begin, end));

      // está lejos del inicio, metemos 0
      if (begin > 1) {
        this.pages.unshift(0, null);
      } else if (begin > 0) {
        this.pages.unshift(0);
      }
      // está lejos del final, metemos max
      if (end < length - 2) {
        this.pages.push(null, this.maxPage);
      } else if (end < length - 1) {
        this.pages.push(this.maxPage);
      }
    } else {
      this.pages = this.availablePages;
    }
  };
}
